export * from "./response";
/**
 * 表单单据状态
 */
export var SequenceStatus;
(function (SequenceStatus) {
    /**
     * 草稿
     */
    SequenceStatus["Draft"] = "DRAFT";
    /**
     * 进行中
     */
    SequenceStatus["Processing"] = "PROCESSING";
    /**
     * 已完成
     */
    SequenceStatus["Completed"] = "COMPLETED";
    /**
     * 已作废
     */
    SequenceStatus["Canceled"] = "CANCELED";
    /**
     * 流程异常
     */
    SequenceStatus["Exception"] = "EXCEPTION";
})(SequenceStatus || (SequenceStatus = {}));
export const sequenceStatusZh = {
    [SequenceStatus.Draft]: "草稿",
    [SequenceStatus.Processing]: "进行中",
    [SequenceStatus.Completed]: "已完成",
    [SequenceStatus.Canceled]: "已作废",
    [SequenceStatus.Exception]: "流程异常"
};
